import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=552ba7fc&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports